import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDataContext } from "./DataContext";
import Skeleton from "@mui/material/Skeleton";

const OurClients = ({ theme }) => {
  const { clients: cachedClients, fetchClients } = useDataContext();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadClients = async () => {
      // Use cached clients if available
      if (cachedClients && cachedClients.length > 0) {
        setClients(cachedClients);
        setLoading(false);
        return;
      }

      // Fetch from API (will be cached in context)
      setLoading(true);
      await fetchClients();
      // Loading will be set false when cachedClients updates
    };

    loadClients();
  }, [cachedClients, fetchClients]);

  // Update clients when cache is populated
  useEffect(() => {
    if (cachedClients && cachedClients.length > 0 && loading) {
      setClients(cachedClients);
      setLoading(false);
    }
  }, [cachedClients, loading]);

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-prev-arrow`}
        style={{ ...style, left: "-15px", zIndex: 1 }}
        onClick={onClick}
      />
    );
  };

  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-next-arrow`}
        style={{ ...style, right: "-15px", zIndex: 1 }}
        onClick={onClick}
      />
    );
  };

  const settings = {
    dots: false, // Removed dots as per user request
    infinite: true,
    speed: 800, // Slower transition for smoothness
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000,
    cssEase: "cubic-bezier(0.87, 0, 0.13, 1)", // Custom ease for premium feel
    pauseOnHover: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true, // Show arrows
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true, // Show arrows
        },
      },
    ],
  };

  const isDark = theme === "dark";

  return (
    <>
      {isDark && (
        <style>{`
          .dark-theme-clients {
            overflow: hidden !important;
          }
          .dark-theme-clients .slick-list {
            overflow: visible !important;
            padding-top: 10px !important;
            padding-bottom: 10px !important;
          }
          .dark-theme-clients .client-card {
            background: #ffffff !important;
            border: 1px solid rgba(255, 255, 255, 0.1) !important;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4) !important;
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) !important;
            border-radius: 16px !important;
            height: 120px !important;
            padding: 8px !important;
          }
          .dark-theme-clients .client-card:hover {
            transform: translateY(-2px) scale(1.01) !important;
            border-color: #e8ff00 !important;
            box-shadow: 0 0 5px rgba(232, 255, 0, 0.25), 0 10px 30px rgba(0, 0, 0, 0.6) !important;
            background: #ffffff !important;
          }
          .dark-theme-clients .client-logo-img {
            max-width: 100% !important;
            max-height: 100% !important;
            width: auto !important;
            height: auto !important;
            object-fit: contain !important;
            filter: grayscale(100%) !important;
            opacity: 0.85 !important;
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) !important;
          }
          .dark-theme-clients .client-card:hover .client-logo-img {
            filter: grayscale(0%) !important;
            opacity: 1 !important;
          }
          .dark-theme-clients .custom-prev-arrow,
          .dark-theme-clients .custom-next-arrow {
            background-color: rgba(255, 255, 255, 0.1) !important;
            border: 1px solid rgba(255, 255, 255, 0.2) !important;
            color: #ffffff !important;
            backdrop-filter: blur(8px) !important;
            width: 38px !important;
            height: 38px !important;
            border-radius: 50% !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            transition: all 0.3s ease !important;
          }
          .dark-theme-clients .custom-prev-arrow:hover,
          .dark-theme-clients .custom-next-arrow:hover {
            background-color: #e8ff00 !important;
            border-color: #e8ff00 !important;
            box-shadow: 0 0 15px rgba(232, 255, 0, 0.4) !important;
          }
          .dark-theme-clients .custom-prev-arrow:before,
          .dark-theme-clients .custom-next-arrow:before {
            color: #ffffff !important;
          }
          .dark-theme-clients .custom-prev-arrow:hover:before,
          .dark-theme-clients .custom-next-arrow:hover:before {
            color: #0b1121 !important;
          }
        `}</style>
      )}
      <section
        className={isDark ? "dark-theme-clients py-lg-5 py-4" : "logo-list-section py-lg-5 py-4 section-background"}
        style={isDark ? {
          background: "transparent",
          paddingTop: "3rem",
          paddingBottom: "3rem"
        } : {}}
      >
        <Container>
          <h2
            className="text-center section-title fw-semibold mb-md-4 mb-3"
            style={isDark ? {
              color: "#ffffff",
              fontSize: "32px",
              fontFamily: '"Poppins", sans-serif',
              fontWeight: 600
            } : {}}
          >
            {isDark ? (
              <>Our Valued <span style={{ color: "#e8ff00" }}>Clients</span></>
            ) : (
              "Our Valued Clients"
            )}
          </h2>

          <Row className="text-center justify-content-center">
            <Col xs={12} className="px-lg-4">
              {loading ? (
                // Skeleton Loader
                <div className="d-flex justify-content-between overflow-hidden">
                  {[1, 2, 3, 4, 5].map((item) => (
                    <div key={item} className="mx-2" style={{ width: "20%" }}>
                      <Skeleton
                        variant="rectangular"
                        height={120}
                        width="100%"
                        style={{ borderRadius: "12px" }}
                        animation="wave"
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <Slider {...settings}>
                  {clients.map((client) => (
                    <div key={client.id} className="p-1">
                      <div className="client-card">
                        <a
                          href={client.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="client-logo-wrapper"
                        >
                          <img
                            src={client.image}
                            alt={client.name}
                            className="client-logo-img"
                            loading="lazy"
                          />
                        </a>
                      </div>
                    </div>
                  ))}
                </Slider>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default OurClients;
